import * as Types from '../graphql.generated';

import { Analytics_Taxonomy_FragmentFragment } from './analyticTaxonomy.fragment.generated';
import { Analytics_Eccomerce_FragmentFragment } from './analyticsEcommerce.fragment.generated';
import { Meta_Info_FragmentFragment } from './metaInfo.fragment.generated';
import { Pagination_FragmentFragment } from './pagination.fragment.generated';
import { Listing_Map_FragmentFragment } from './listingMap.fragment.generated';
import { Seo_Blurb_FragmentFragment } from './seoBlurb.fragment.generated';
import { Links_FragmentFragment } from './links.fragment.generated';
import { Polygon_FragmentFragment } from './polygon.fragment.generated';
import { gql } from '@apollo/client';
import { Analytics_Taxonomy_FragmentFragmentDoc } from './analyticTaxonomy.fragment.generated';
import { Analytics_Eccomerce_FragmentFragmentDoc } from './analyticsEcommerce.fragment.generated';
import { Meta_Info_FragmentFragmentDoc } from './metaInfo.fragment.generated';
import { Pagination_FragmentFragmentDoc } from './pagination.fragment.generated';
import { Listing_Map_FragmentFragmentDoc } from './listingMap.fragment.generated';
import { Seo_Blurb_FragmentFragmentDoc } from './seoBlurb.fragment.generated';
import { Links_FragmentFragmentDoc } from './links.fragment.generated';
import { Polygon_FragmentFragmentDoc } from './polygon.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type GetListingMapViewQueryVariables = Types.Exact<{
    path: Types.Scalars['String'];
}>;

export type GetListingMapViewQuery = { __typename?: 'Query' } & {
    searchResults?: Types.Maybe<
        { __typename?: 'Results' } & Pick<Types.Results, 'polyenc'> & {
                analyticsTaxonomy?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsTaxonomy';
                    } & Analytics_Taxonomy_FragmentFragment
                >;
                analyticsEcommerce?: Types.Maybe<
                    {
                        __typename?: 'AnalyticsEcommerce';
                    } & Analytics_Eccomerce_FragmentFragment
                >;
                metaInfo?: Types.Maybe<
                    { __typename?: 'Meta' } & Meta_Info_FragmentFragment
                >;
                pagination?: Types.Maybe<
                    { __typename?: 'Pagination' } & Pagination_FragmentFragment
                >;
                listings?: Types.Maybe<
                    { __typename?: 'Listings' } & {
                        regular?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_Map_FragmentFragment
                                >
                            >
                        >;
                        featured?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_Map_FragmentFragment
                                >
                            >
                        >;
                        extended?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    {
                                        __typename?: 'Listing';
                                    } & Listing_Map_FragmentFragment
                                >
                            >
                        >;
                    }
                >;
                seoBlurb?: Types.Maybe<
                    { __typename?: 'SeoBlurb' } & Seo_Blurb_FragmentFragment
                >;
                links?: Types.Maybe<
                    { __typename?: 'Links' } & Links_FragmentFragment
                >;
                polygonV2?: Types.Maybe<
                    { __typename?: 'Polygon' } & Polygon_FragmentFragment
                >;
            }
    >;
};

export const GetListingMapViewDocument = gql`
    query getListingMapView($path: String!) {
        searchResults(path: $path) {
            analyticsTaxonomy {
                ...ANALYTICS_TAXONOMY_FRAGMENT
            }
            analyticsEcommerce {
                ...ANALYTICS_ECCOMERCE_FRAGMENT
            }
            metaInfo {
                ...META_INFO_FRAGMENT
            }
            pagination {
                ...PAGINATION_FRAGMENT
            }
            listings {
                regular {
                    ...LISTING_MAP_FRAGMENT
                }
                featured {
                    ...LISTING_MAP_FRAGMENT
                }
                extended {
                    ...LISTING_MAP_FRAGMENT
                }
            }
            seoBlurb {
                ...SEO_BLURB_FRAGMENT
            }
            links {
                ...LINKS_FRAGMENT
            }
            polygonV2(path: $path) {
                ...POLYGON_FRAGMENT
            }
            polyenc
        }
    }
    ${Analytics_Taxonomy_FragmentFragmentDoc}
    ${Analytics_Eccomerce_FragmentFragmentDoc}
    ${Meta_Info_FragmentFragmentDoc}
    ${Pagination_FragmentFragmentDoc}
    ${Listing_Map_FragmentFragmentDoc}
    ${Seo_Blurb_FragmentFragmentDoc}
    ${Links_FragmentFragmentDoc}
    ${Polygon_FragmentFragmentDoc}
`;

/**
 * __useGetListingMapViewQuery__
 *
 * To run a query within a React component, call `useGetListingMapViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingMapViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingMapViewQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetListingMapViewQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetListingMapViewQuery,
        GetListingMapViewQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetListingMapViewQuery,
        GetListingMapViewQueryVariables
    >(GetListingMapViewDocument, options);
}
export function useGetListingMapViewLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetListingMapViewQuery,
        GetListingMapViewQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetListingMapViewQuery,
        GetListingMapViewQueryVariables
    >(GetListingMapViewDocument, options);
}
export type GetListingMapViewQueryHookResult = ReturnType<
    typeof useGetListingMapViewQuery
>;
export type GetListingMapViewLazyQueryHookResult = ReturnType<
    typeof useGetListingMapViewLazyQuery
>;
export type GetListingMapViewQueryResult = Apollo.QueryResult<
    GetListingMapViewQuery,
    GetListingMapViewQueryVariables
>;
